export const SUBSCRIPTION_CATEGORY_ID = 3;
export const SUBSCRIPTION_SUBCATEGORY_ID = 6;